var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfession(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.702 2.095l-6.174 3.43c-1.298.721-1.298 2.587 0 3.308l6.174 3.43a4.733 4.733 0 004.594 0l6.174-3.43c1.298-.721 1.298-2.587 0-3.308l-6.174-3.43a4.733 4.733 0 00-4.594 0z",
    stroke: "#9495A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26 10.095a7.347 7.347 0 00.19 3.193l.118.41c.656 2.294 2.612 4.016 5.026 4.428.93.158 1.88.158 2.81 0 2.415-.412 4.37-2.134 5.026-4.427l.118-.411a7.346 7.346 0 00.19-3.193",
    stroke: "#9495A0"
  })));
}
export default SvgProfession;